const coins = ['BTC','ETH', 'BCH'];

const coinDesc = {
  BTC: { algorithm: 'SHA256', unit: 'TH', unitFactor: 10 ** 12, totalUnit: 'EH', totalUnitFactor: 10 ** 18, halvingBlock: 630000 },
  BCH: { algorithm: 'SHA256', unit: 'TH', unitFactor: 10 ** 12, totalUnit: 'EH', totalUnitFactor: 10 ** 18, halvingBlock: 630000 },
  ETH: { algorithm: 'DAGGERHASHIMOTO',  unit: 'MH', unitFactor: 10 ** 6, totalUnit: 'TH', totalUnitFactor: 10 ** 12 }
};

const algorithmDesc = {
  SHA256: { payoffType: ['BTC', 'BCH'] },
  DAGGERHASHIMOTO: { payoffType: ['ETH'] }
};

export { coins, coinDesc, algorithmDesc }